export enum MusicColorScheme {
  black = "black",
  blue = "blue",
  cyan = "cyan",
  green = "green",
  orange = "orange",
  purple = "purple",
  red = "red",
}

export const MUSIC_COLOR_SCHEMES: Record<MusicColorScheme, { background: string; colorScheme: MusicColorScheme }> = {
  black: {
    colorScheme: MusicColorScheme.black,
    background: "linear-gradient(180deg,#2a2a2a 0%, #111111 100%)",
  },
  blue: {
    colorScheme: MusicColorScheme.blue,
    background: "linear-gradient(180deg, #044286 0%, #072450 100%)",
  },
  cyan: {
    colorScheme: MusicColorScheme.cyan,
    background: "linear-gradient(180deg, #288B8B 0%, #155150 100%)",
  },
  green: {
    colorScheme: MusicColorScheme.green,
    background: "linear-gradient(180deg, #229B52 0%, #11552D 100%)",
  },
  orange: {
    colorScheme: MusicColorScheme.orange,
    background: "linear-gradient(180deg, #C86B2D 0%, #9B4826 100%);",
  },
  purple: {
    colorScheme: MusicColorScheme.purple,
    background: "linear-gradient(180deg, #7035AB 0%, #3D1763 100%)",
  },
  red: {
    colorScheme: MusicColorScheme.red,
    background: "linear-gradient(180deg, #AD3838 0%, #681313 100%)",
  },
};

export function getColorScheme(colorScheme: string) {
  return MUSIC_COLOR_SCHEMES[colorScheme as MusicColorScheme] || MUSIC_COLOR_SCHEMES.red;
}
